import React from 'react';
import { Stack, Typography } from '@mui/material';
import { StorefrontOutlined as StoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Campo opcional — texto livre da IA, por isso trunca em uma linha só.
const LeadTargetBusiness = ({ targetBusiness }) => {
  const { t } = useTranslation();

  if (!targetBusiness) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <StoreIcon
        fontSize="small"
        color="action"
        titleAccess={t('leads.targetBusiness')}
        sx={{ flexShrink: 0 }}
      />
      <Typography
        variant="body2"
        color="text.secondary"
        noWrap
        sx={{ flex: 1, minWidth: 0 }}
      >
        {targetBusiness}
      </Typography>
    </Stack>
  );
};

export default LeadTargetBusiness;
